var scope_0 = require('/home/james/code/jamestharpe.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ed916114b5aed310378d12e39f9331a.js').default;
var scope_1 = require('/home/james/code/jamestharpe.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9950aba6b68e72d14cc169620fe591fe.js').default;
var scope_2 = require('/home/james/code/jamestharpe.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a461d624ac9d1af3420b71fd3aee1a10.js').default;
var scope_3 = require('/home/james/code/jamestharpe.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b385fa550c7b511f614a4b632f0b981b.js').default;
var scope_4 = require('/home/james/code/jamestharpe.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    